import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/aromatics/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/aromatics/industry/styreneNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/aromatics/industry/getStyreneNewsInfo/${id}`,
        method: 'get',
    })
}

// 装置动态列表
export function deviceList(query) {
    return request({
        url: '/aromatics/industry/styreneDeviceList',
        method: 'get',
        params: query
    })
}

// 装置动态详情
export function deviceDetail(id) {
    return request({
        url: `/aromatics/industry/getStyreneDeviceInfo/${id}`,
        method: 'get',
    })
}

// 利润列表
export function profitList(query) {
    return request({
        url: '/aromatics/industry/styrenePriceList',
        method: 'get',
        params: query
    })
}

// 利润详情
export function profitDetail(id) {
    return request({
        url: `/aromatics/industry/getStyrenePriceInfo/${id}`,
        method: 'get',
    })
}

// 产量列表
export function yieldList(query) {
    return request({
        url: '/aromatics/industry/styreneYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(id) {
    return request({
        url: `/aromatics/industry/getStyreneYieldInfo/${id}`,
        method: 'get',
    })
}

// 库存列表（首页）
export function stockNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/stock/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/aromatics/metatron/stock/styreneStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: `/aromatics/metatron/stock/detailsStyreneStock`,
        method: 'get',
        params: query
    })
}

// 价格列表（无权限）
export function priceNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/price/noAuth/petroleumPlaceList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/aromatics/metatron/price/styrenePriceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/aromatics/metatron/price/detailsStyrenePriceInfo`,
        method: 'get',
        params: query
    })
}

// 开工率列表(首页)
export function rateNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/rate/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 开工率列表
export function rateList(query) {
    return request({
        url: '/aromatics/metatron/rate/styreneRateList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: `/aromatics/metatron/rate/detailsStyreneRate`,
        method: 'get',
        params: query
    })
}

// 研究报告列表(首页无权限)
export function reportNoAuthList(query) {
    return request({
        url: '/aromatics/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/aromatics/report/reportStyreneList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/aromatics/report/boardStyreneInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/aromatics/report/technicalStyreneList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/aromatics/report/technicalStyreneInfo/${id}`,
        method: 'get',
    })
}

// 进出口列表(首页)
export function exitNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/exit/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 进出口列表
export function exitList(query) {
    return request({
        url: '/aromatics/metatron/exit/styreneTotalList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitDetail(query) {
    return request({
        url: `/aromatics/metatron/exit/detailsStyreneTotal`,
        method: 'get',
        params: query
    })
}

// 塑料行业动态列表
export function plasticsIndustryList(query) {
    return request({
        url: '/aromatics/industry/styrenePlasticList',
        method: 'get',
        params: query
    })
}

// 塑料行业动态详情
export function plasticsIndustryDetail(id) {
    return request({
        url: `/aromatics/industry/getStyrenePlasticInfo/${id}`,
        method: 'get',
    })
}

// 价格及利润列表
export function priceProfitList(query) {
    return request({
        url: '/aromatics/metatron/price/styreneProfitList',
        method: 'get',
        params: query
    })
}

// 价格及利润详情
export function priceProfitDetail(query) {
    return request({
        url: `/aromatics/metatron/price/detailsStyreneProfitInfo`,
        method: 'get',
        params: query
    })
}

// ABS/EPS开工率列表
export function absRateList(query) {
    return request({
        url: '/aromatics/metatron/rate/styreneLetterList',
        method: 'get',
        params: query
    })
}

// ABS/EPS开工率详情
export function absRateDetail(query) {
    return request({
        url: `/aromatics/metatron/rate/detailsStyreneLetter`,
        method: 'get',
        params: query
    })
}

// 首页列表（无权限）
export function queryPageList(query) {
    return request({
        url: '/aromatics/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 产业链
export function chainList(query) {
    return request({
        url: '/aromatics/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 三年折线图
export function lineData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}

// 三年地图
export function threeLineData(query) {
    return request({
        url: '/aromatics/druidEnter/getLineChart',
        method: 'get',
        params: query
    })
}
